import React from 'react';
import { LuMail, LuMessageCircle, LuPhoneCall } from 'react-icons/lu';
import { FaFacebookF } from 'react-icons/fa';

const contactMethods = [
  {
    title: 'Call',
    value: '+94 77 859 0241',
    helper: 'Available for calls',
    icon: LuPhoneCall,
    link: 'tel:+94778590241',
    cta: 'Call Now',
  },
  {
    title: 'WhatsApp',
    value: '+94 77 859 0241',
    helper: 'Chat with us on WhatsApp',
    icon: LuMessageCircle,
    link: 'https://wa.me/94778590241',
    cta: 'Message',
  },
  {
    title: 'Email',
    value: 'nithujanithu96@gmail.com',
    helper: 'Response within 24 hours',
    icon: LuMail,
    link: 'mailto:nithujanithu96@gmail.com',
    cta: 'Send Email',
  },
  {
    title: 'Facebook',
    value: 'Nithuja Cakes',
    helper: 'Connect with us on Facebook',
    icon: FaFacebookF,
    link: 'https://www.facebook.com/share/17Yv87aXFg/',
    cta: 'Visit Page',
  },
];


const AnimatedBackground = () => (
  <div
    aria-hidden="true"
    className="absolute inset-0 w-full h-full overflow-hidden z-0 pointer-events-none"
  >
    <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-[120vw] h-[120vw] bg-gradient-to-br from-pink-400 via-pink-200 to-yellow-100 opacity-30 rounded-full blur-3xl animate-spin-slow" />
    <div className="absolute bottom-0 right-0 w-72 h-72 bg-pink-300 opacity-20 rounded-full blur-2xl animate-pulse" />
    <div className="absolute top-1/3 left-0 w-40 h-40 bg-yellow-200 opacity-20 rounded-full blur-2xl animate-bounce" />
  </div>
);

const ContactSection = () => (
  <section className="relative py-16 sm:py-20 px-3 sm:px-4 md:px-6 lg:px-8 bg-pink-600 text-white overflow-hidden">
    <AnimatedBackground />
    <div className="relative z-10 max-w-6xl mx-auto">
      <div className="text-center mb-12 md:mb-16 px-2 sm:px-0">
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold font-serif mb-4 drop-shadow-lg">
          Ready to Order or Have Questions?
        </h2>
        <p className="text-base sm:text-lg md:text-xl max-w-2xl mx-auto font-light">
          We're here to help bring your cake vision to life!
        </p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 md:gap-8">
        {contactMethods.map(({ title, value, helper, icon: Icon, link, cta }) => (
          <div
            key={title}
            className="relative flex flex-col items-center bg-white/80 p-4 sm:p-6 md:p-8 rounded-3xl shadow-2xl backdrop-blur-md min-h-[220px] sm:min-h-[240px] border border-pink-300/60 transition-all duration-300 group overflow-hidden hover:scale-[1.04] hover:bg-white/90 hover:shadow-pink-300/40 hover:shadow-2xl"
          >
            {/* Animated border effect */}
            <span className="absolute inset-0 rounded-3xl border-2 border-transparent group-hover:border-pink-400 group-hover:shadow-[0_0_24px_4px_rgba(244,114,182,0.25)] transition-all duration-300 pointer-events-none z-10"></span>
            <div className="flex items-center justify-center mb-4 w-16 h-16 rounded-full bg-gradient-to-br from-pink-600 to-pink-400 shadow-lg border-2 border-pink-400 group-hover:scale-110 transition-transform duration-300 z-20">
              <Icon className="w-8 h-8 drop-shadow-md" aria-hidden="true" />
            </div>
            <h3 className="text-base sm:text-lg md:text-xl font-extrabold mb-1 text-center text-pink-800 drop-shadow-md z-20">{title}</h3>
            <p className="text-pink-900 text-sm sm:text-base md:text-lg font-bold text-center break-all drop-shadow-sm z-20">{value}</p>
            <p className="text-xs sm:text-sm text-pink-700 mt-1 text-center font-medium z-20">{helper}</p>
            <a
              href={link}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-auto pt-4 inline-block px-4 sm:px-5 py-2 sm:py-2.5 rounded-full bg-gradient-to-r from-pink-700 to-pink-500 hover:from-pink-800 hover:to-pink-600 text-white font-bold text-xs sm:text-sm shadow-xl border-2 border-pink-400 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-pink-300 z-20 group-hover:scale-105"
            >
              {cta}
            </a>
            {/* Soft glow effect */}
            <span className="absolute -bottom-8 -right-8 w-32 h-32 bg-pink-200 opacity-30 rounded-full blur-2xl z-0"></span>
            <span className="absolute -top-8 -left-8 w-24 h-24 bg-yellow-100 opacity-20 rounded-full blur-2xl z-0"></span>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default ContactSection;
